export default "__VITE_ASSET__CaLcM_fM__"